import { containNumber } from '../../utils/main'
import { generateGetDIDs, DIDS_TIME_LIMIT, 
    /*generateAddDIDToCart, generateRemoveDIDFromCart*/ } from '../reducers/statics/consts'

export const SET_SEARCH_TERM = "SET_SEARCH_TERM";
export const SET_RESULTS = "SET_RESULTS";
export const SET_LOADING_DID_RESULTS = "SET_LOADING_DID_RESULTS";
export const SET_ERROR_DID_RESULTS = "SET_ERROR_DID_RESULTS";
export const UPDATE_SELECTED_DIDS = "UPDATE_SELECTED_DIDS";
//export const SET_SMS_MARKETING = "SET_SMS_MARKETING";
export const UPDATE_BULK_SMS_PACKAGE = "UPDATE_BULK_SMS_PACKAGE";
export const SET_BULK_SMS_PACKAGES = "SET_BULK_SMS_PACKAGES";
export const SELECT_SMS_TAB = "SELECT_SMS_TAB";

export const setAddedDIDs = (res) => {
    return (dispatch) => {
        res = res.filter(item => item.DID && new Date().getTime() - item.addedAt <= DIDS_TIME_LIMIT);
        dispatch({type: UPDATE_SELECTED_DIDS, newResults: res})
    }
}
export const setBulkPackagesSelected = (newValue) => {
    return (dispatch) => {
        dispatch({type: SET_BULK_SMS_PACKAGES, newValue})
    }
}

export const setSearchTerm = (value) => {
    return (dispatch, getState) => {
        //this.searchInputRef.focus();
        const { searchTerm } = getState().DIDsReducer;
        if(
            value === "1" || value === "0" ||
            (
                (
                    !(searchTerm.length <= 0 && value.length > 0)
                )
                &&
                (
                    (searchTerm.length > 0 && !isNaN(Number(searchTerm)) && value.length > 0 && isNaN(Number(value))) ||
                    (isNaN(Number(searchTerm)) && value.length > 0 && containNumber(value) && value.length != 3) ||
                    (searchTerm.length > 0 && isNaN(Number(searchTerm)) && value.length > 15) ||
                    (!isNaN(Number(searchTerm)) && value.length > 3)
                )
            )
        ) {
            return;
        }

        dispatch({type: SET_SEARCH_TERM, newValue: value})
    }
}

export const performSearch = (areaCode) => {
    return (dispatch, getState) => {
        if(getState().DIDsReducer.results.isLoading) return;

        dispatch({type: SET_LOADING_DID_RESULTS, newValue: true})

        fetch(generateGetDIDs(areaCode), { method: "POST" })
        .then(r => r.json())
        .then(res => {
            if(res.ERROR && res.ERROR == "No Results") {
                throw({message: "No numbers were found for this area code or prefix"})
            } else {
                dispatch({type: SET_RESULTS, newResults: res})
            }
        })
        .catch(err => {
            dispatch({type: SET_ERROR_DID_RESULTS, errorMessage: err.message})
        });
        //dispatch({type: SET_RESULTS, newResults: didNumbers})
    }
}

export const toggleDID = (DID) => {
    return (dispatch, getState) => {
        const doesExist = getState().DIDsReducer.DIDsAdded.find(item => item.DID == DID.num);
        var newDIDAry = getState().DIDsReducer.DIDsAdded;
        if(doesExist) {
            //remove
            newDIDAry = newDIDAry.filter(item => item.DID != DID.num);
            // fetch(generateRemoveDIDFromCart(DID.id, DID.num, DID.price, DID.setup, DID.api), {method: "POST"})
            // .then(r => r.status)
            // .then(resCode => {
            //     console.log(resCode);
            // })
            // .catch(err => {
            //     console.log(err);
            // })
        } else {
            //add
            newDIDAry.push({DID: DID.num, api: DID, addedAt: new Date().getTime(), price: DID.price});
            // fetch(generateAddDIDToCart(DID.id, DID.num, DID.price, DID.setup, DID.api), {method: "POST"})
            // .then(r => r.status)
            // .then(resCode => {
            //     console.log(resCode);
            // })
            // .catch(err => {
            //     console.log(err);
            // })
        }
        dispatch({type: UPDATE_SELECTED_DIDS, newResults: newDIDAry})
    }
}

export const toggleDIDAddOn = (DID, addOnName) => {
    return (dispatch, getState) => {
        var newDIDAry = getState().DIDsReducer.DIDsAdded.map(item => {
            if(item.DID == DID) {
                item[addOnName] = !item[addOnName];
            }
            return item;
        });
        dispatch({type: UPDATE_SELECTED_DIDS, newResults: newDIDAry})
    }
}

/*export const setIsSmsMarketing = (newValue) => {
    return (dispatch, getState) => {
        dispatch({type: SET_SMS_MARKETING, newValue })
    }
}*/

export const selectSMSTab = (newValue) => {
    return (dispatch, getState) => {
        dispatch({type: SELECT_SMS_TAB, newValue })
    }
}

export const updateBulkSmsPackage = (packageId, newAmount) => {
    return (dispatch, getState) => {
        newAmount = formatNewBulkSmsPackage(newAmount);
        if(newAmount !== false) {
            dispatch({type: UPDATE_BULK_SMS_PACKAGE, packageId, newAmount})
        }
    }
}
export const addReduceBulkSmsPackage = (packageId, isAdding) => {
    return (dispatch, getState) => {
        const newAmount = formatNewBulkSmsPackage(
            getState().DIDsReducer.bulkPackagesSelected[packageId] + (isAdding ? + 1 : - 1)
        );
        if(newAmount !== false) {
            dispatch({type: UPDATE_BULK_SMS_PACKAGE, packageId, newAmount})
        }
    }
}
const formatNewBulkSmsPackage = (newCount) => {
    if(isNaN(Number(newCount)) || newCount.toString().includes(".")) return false;
    if(newCount < 0) newCount = 0;
    if(newCount > 99) newCount = 99;
    return Number(newCount);
}

export const clearBulkSmsPackages = () => {
    return (dispatch, getState) => {
        const { bulkPackagesSelected } = getState().DIDsReducer;
        Object.keys(bulkPackagesSelected).forEach(key => {
            dispatch({type: UPDATE_BULK_SMS_PACKAGE, packageId: key, newAmount: 0})
        })
    }
}

